module.exports = __webpack_public_path__ + "media/St 4-Question 15-hint.27e390c5.wav";